"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ProductParametersList = _interopRequireDefault(require("@sprinx/react-com/ProductParametersList"));

var _useTransformProductParamsToGroups = _interopRequireDefault(require("@sprinx/react-products/useTransformProductParamsToGroups"));

var _useProductParameters = _interopRequireDefault(require("../../../products/useProductParameters"));

var _mergeDuplicateParamsInGroups = _interopRequireDefault(require("../../../products/mergeDuplicateParamsInGroups"));

var _parametersFilter = _interopRequireDefault(require("./parametersFilter"));

function ProductDetailParameterList(_ref) {
  var product = _ref.product,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["product"]);
  var productParameters = (0, _useProductParameters.default)(product.id);
  product = (0, _extends2.default)({}, product, {
    parameters: productParameters
  });
  var transformedParamsToGroups = (0, _useTransformProductParamsToGroups.default)({
    parametersFilter: _parametersFilter.default,
    toTransferCfg: [],
    translationPrefix: 'com/product'
  }, product);

  var transformedParamsToGroupsUnique = _react.default.useMemo(function () {
    return (0, _mergeDuplicateParamsInGroups.default)(transformedParamsToGroups);
  }, [transformedParamsToGroups]);

  return /*#__PURE__*/_react.default.createElement(_ProductParametersList.default, (0, _extends2.default)({
    parameterGroups: transformedParamsToGroupsUnique
  }, rest));
}

process.env.NODE_ENV !== "production" ? ProductDetailParameterList.propTypes = {
  // classes: PropTypes.shape({
  //   root: PropTypes.string,
  // }),
  // className: PropTypes.string,
  product: _propTypes.default.shape({
    id: _propTypes.default.string.isRequired,
    parameters: _propTypes.default.arrayOf(_propTypes.default.shape({}))
  })
} : void 0;
ProductDetailParameterList.defaultProps = {
  // classes: undefined,
  // className: undefined,
  product: undefined
};
var _default = ProductDetailParameterList;
exports.default = _default;